import { useQuery } from "@tanstack/react-query";
import { vinculosApi } from "../api/vinculosApi";

export function useVinculoQuery(id) {
  return useQuery({
    queryKey: ["vinculos", id],
    queryFn: () => vinculosApi.get(id),
    enabled: Boolean(id),
  });
}
